import { useMemo } from 'react'
import { useActionProps } from 'client/fragments/listerFragment/hooks/useActionProps'
import throttle from 'client/common/throttle'
import { onFilterChange, onFilterClear } from 'client/fragments/listerFragment/store/actions/filterActions'

export const OPTION_CLICK_DELAY = 300
export function useFilters({ filters: { collection, active }, t }) {
  const handlerCommonProps = useActionProps()
  const { format, lang, categoryCode } = handlerCommonProps
  const preventClick = !categoryCode

  const filterProps = useMemo(
    () => ({ ...handlerCommonProps, collection, active }),
    [handlerCommonProps, collection, active]
  )

  const onChange = params => throttle(() => onFilterChange(filterProps)(params), OPTION_CLICK_DELAY)
  const onClear = onFilterClear(filterProps)
  const buttonActiveText = t('lister.filters.collapse')
  const buttonInactiveText = t('lister.filters.extend')
  const rangeFilterToText = t('lister.filters.range_to')

  return { onChange, onClear, preventClick, format, lang, t, buttonActiveText, buttonInactiveText, rangeFilterToText }
}
